/**
 * Generated bundle index. Do not edit.
 */
export * from './index';
export { AnimationLoader as ɵc } from './lib/animation-loader';
export { CacheableAnimationLoader as ɵd } from './lib/cacheable-animation-loader/cacheable-animation-loader';
export { LOTTIE_OPTIONS as ɵb } from './lib/symbols';
//# sourceMappingURL=ngx-lottie.js.map